import React from 'react';
import cardStyle from '~/components/Commons/Card/cardStyle';
import { Box, CardProps as MuiCardProps } from '@mui/material';

export interface CustomCardProps extends MuiCardProps {
  children?: React.ReactNode;
  stats?: boolean;
}

const Card = React.forwardRef<HTMLDivElement, CustomCardProps>(({ ...props }, ref) => {
  const { children, stats } = props;

  const cardSx = {
    ...cardStyle.card,
    ...(stats && cardStyle.stats),
  };
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box ref={ref} sx={cardSx} {...props}>
      {children}
    </Box>
  );
});

export default Card;
